import request from '@/utils/request'

export function getOssParams() {
  return request({
    url: `/tenantadmin/oss`,
    method: 'get'
  })
}

export function fileUpload(data, params) {
  console.log('params: ', params);
  let url = '/api/v1/file/upload'
  if(params){
    url = url + '?' + new URLSearchParams(params).toString()
  }
  console.log('url: ', url);
  return request({
    url,
    method: 'post',
    data,
    params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

